import styled from 'styled-components'

export default styled.div.attrs({
  className: 'title'
})`
  flex: auto;
  display: -ms-flexbox;
  -ms-flexbox: auto;
  font-size: 13px;
  line-height: 18px;
  max-width: 100%;
  overflow: hidden;
  & span {
    font-weight: bold;
    white-space: nowrap;
  }
`
